var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-slider",
        _vm._b(
          {
            on: { change: _vm.handleChange },
            model: {
              value: _vm.initValue,
              callback: function ($$v) {
                _vm.initValue = $$v
              },
              expression: "initValue",
            },
          },
          "el-slider",
          Object.assign({}, _vm.item),
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }